import AppConstants from '../../../../constants/AppConstants';
import PublisherActions from '../../../../actions/PublisherActions';
import CustomNotify from '../../../Notify';
import UserStore from '../../../../stores/UserStore';

const eventsMethod = {
    before: AppConstants.PAYMENT_DETAILS_METHOD_START_LOADING,
    success: AppConstants.PAYMENT_DETAILS_METHOD_SUCCESS,
    fail: AppConstants.PAYMENT_DETAILS_METHOD_FAIL
};

export const actions = {
    submitLinkConfirm(id) {
        PublisherActions.sendActivationCode({id}).then(() => {
            actions.searchMehod(id);
        });
    },

    searchMehod(id, onSucces) {
        PublisherActions.getPaymentDetails({ids: id}, eventsMethod).then(() => {
            onSucces && onSucces();
        });
    },

    activationPaymentDetails(id, code, onSuccess, onFail) {
        const params = {
            payment_details_id: id,
            payment_details_activation_code: code
        };

        PublisherActions.edit(params).then(data => {
            CustomNotify(UserStore.getTranslation().notyMessages['update']);
            PublisherActions.getPaymentDetails();
            onSuccess();
        }).catch(err => {
            const { payment_details_activation_code } = err.error.invalid_parameters;
            onFail(payment_details_activation_code);
        });
    }
};
